var $def   = require('./$.def')
  , define = require('./$.object-define');

$def($def.S + $def.F, 'Object', {define: define});